import type { SendRequestType } from '@/lib/utils/shared/httpTools'
import httpTools from '@/lib/utils/shared/httpTools'

interface HydraGetOrderHistoryProps {
  hydraToken: string
  page: number
}

export type HydraGetOrderHistoryOrderItem = {
  ResultId: number
  creator: {
    humanName: {
      fullName: string
    }
  }
  currency: string
  customer: {
    humanName: {
      fullName: string
      firstName: string
      lastName: string
      'fullName@en': string
    }
    id: {
      unicity: number
    }
    href: string
  }
  dateCreated: string
  fulfillmentStatus: string
  id: {
    iota?: string
    unicity: string
    unity?: string
  }
  lines: {
    items: {
      catalogSlide: {
        content: {
          description: string
        }
      }
      item: {
        id: {
          unicity: number
        }
      }
      quantity: number
      quantityDetails: {
        quantityBackordered: number
      }
      terms: {
        priceEach: number
        pvEach: number
        taxablePriceEach: number
        tax?: {
          amount: number
          percentage?: number
        }
      }
      kitChildren?: {
        catalogSlide: {
          content: {
            description: string
          }
        }
        item: {
          id: {
            unicity: number
          }
        }
        quantity: number
      }[]
    }[]
  }
  market: string
  paymentStatus: string
  shipToName: {
    fullName: string
    firstName: string
    lastName: string
    'fullName@en': string
  }
  shipments: {
    items: {
      dateShipped?: string
    }[]
  }
  source: {
    agent: string
    medium: string
    version: string
    platform?: string
    referrer?: string
  }
  status: string
  terms: {
    discount: {
      amount: number
    }
    freight: {
      amount: number
    }
    period: string
    pv: number
    subtotal: number
    tax: {
      amount: number
    }
    taxableTotal: number
    total: number
  }
  transactions: {
    aggregate: {
      amount: number
    }
  }
  type: string
  href: string
}

export type HydraGetOrderHistoryResponse = {
  items: HydraGetOrderHistoryOrderItem[]
}

export const ORDER_PER_PAGE = 10

export const HydraGetOrderHistory = ({
  hydraToken,
  page,
}: HydraGetOrderHistoryProps) => {
  const url = `/customers/me/orders?expand=order&limit=${
    ORDER_PER_PAGE + 1
  }&offset=${page * ORDER_PER_PAGE}`

  const request: SendRequestType = {
    method: 'GET',
    url,
    token: hydraToken,
  }

  return httpTools.sendRequest<HydraGetOrderHistoryResponse>(request)
}
